module.exports = __webpack_public_path__ + "static/media/Formoplast_2018_IND_Politika_vaznagrajdeniya.4250842c.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2019/Formoplast_2018_IND_Politika_vaznagrajdeniya.pdf
// module id = 128
// module chunks = 0